//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: '',
  components: {},
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    graph: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      default_formed_expr_options: [],
      default_expr_content_options: [],
      localDefaultFormedExprId: null,
      localDefaultExprContentId: null,
    };
  },
  computed: {
    defaultFormedExprId() {
      return (
        this.localDefaultFormedExprId ||
        (this.value.default_formed_expr_v1 && this.value.default_formed_expr_v1.id)
      );
    },
    defaultExprContentId() {
      return (
        this.localDefaultExprContentId ||
        (this.value.default_expr_content_v1 && this.value.default_expr_content_v1.id)
      );
    },
  },
  watch: {
    value: {
      handler(newVal) {
        // 同步本地状态与 props
        this.localDefaultFormedExprId =
          newVal.default_formed_expr_v1 && newVal.default_formed_expr_v1.id;
        this.localDefaultExprContentId =
          newVal.default_expr_content_v1 && newVal.default_expr_content_v1.id;
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.updateOptionsFromEdges();
  },
  methods: {
    valueUpdate(path, value) {
      this.$emit('update', path, value);
    },
    updateDefaultExprContent(e) {
      // 立即更新本地状态
      this.localDefaultExprContentId = e;
      this.localDefaultFormedExprId = null;

      this.valueUpdate('default_formed_expr_v1', undefined);
      const selectedOption = this.default_expr_content_options.find((item) => item.id === e);
      if (selectedOption) {
        this.valueUpdate('default_expr_content_v1', {
          id: selectedOption.id,
          value: selectedOption.value,
        });
      }
    },
    updateDefaultFormedExpr(e) {
      // 立即更新本地状态
      this.localDefaultFormedExprId = e;
      this.localDefaultExprContentId = null;

      const selectedOption = this.default_formed_expr_options.find((item) => item.id === e);
      if (selectedOption) {
        this.valueUpdate('default_formed_expr_v1', {
          id: selectedOption.id,
          value: selectedOption.value,
        });
      }
      this.valueUpdate('default_expr_content_v1', undefined);
    },
    updateOptionsFromEdges() {
      const { edges = [] } = this.graph.save() || {};
      const filterEdgesBySource = edges.filter((edge) => edge.source === this.value.id);

      this.default_expr_content_options = filterEdgesBySource
        .filter((edge) => edge.expr_content)
        .map((edge) => ({
          id: edge.id,
          label: edge.expr_name,
          value: edge.expr_content,
        }));

      this.default_formed_expr_options = filterEdgesBySource
        .filter((edge) => {
          const { formed_expr } = edge;
          return formed_expr?.conditionals?.some((condition) => condition.field !== '');
        })
        .map((edge) => ({
          id: edge.id,
          label: edge.expr_name,
          value: edge.formed_expr,
        }));
    },
  },
};
